import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { OpportunityType } from '../../sales-opportunities/interface';

@Injectable()
export class OpportunityTypeFilterStoreService {
  availableTypes$$ = new BehaviorSubject<OpportunityType[]>([
    {
      id: '',
      displayName: 'Not specified',
    },
    {
      id: 'new-business',
      displayName: 'New Business',
    },
    {
      id: 'existing-business',
      displayName: 'Existing Business',
    },
  ]);

  availableTypes$ = this.availableTypes$$.asObservable();
}
